import { apiGet, apiGetList, apiPost, apiPut, apiDelete } from "services/api";

/* --- Группы сотрудников (должности) --- */

export const getEmployeesGroups = () =>
  apiGetList("users/get-groups", { page: 1, pageSize: 500 });

export const createEmployeesGroup = ({ name, accessList }) =>
  apiPost("users/user-group", { name, accessList });

export const updateEmployeesGroup = ({ usersgroupid, name, accessList }) =>
  apiPut("users/user-group", { usersgroupid, name, accessList });

export const deleteEmployeesGroup = (usersgroupid) =>
  apiDelete("users/user-group", { usersgroupid: Number(usersgroupid) });

/* --- Доступы --- */

export const getAccessList = (forOffice) =>
  apiGetList("users/access", { forOffice, page: 1, pageSize: 500 });

/* --- Сотрудники --- */

export const getEmployees = ({ groupId } = {}) =>
  apiGetList("users/workers", {
    page: 1,
    pageSize: 500,
    group_id: groupId ?? null,
  });

export const createEmployee = (payload) =>
  apiPost("users/create-worker", payload);

export const updateEmployee = (payload) =>
  apiPut("users/update-worker", payload);

export const deleteEmployee = (usersid) =>
  apiPost("users/delete-worker", { usersid: Number(usersid) });

export const reassignEmployee = ({ usersgroupid, usersid }) =>
  apiPut("users/reassign-worker", {
    usersgroupid: Number(usersgroupid),
    usersid: Number(usersid),
  });
